import SupplyLandingPage from './containers/SupplyLandingPage';

export default function initPage() {
  return SupplyLandingPage;
}
